// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalContent_wrapper__eWhA9","body":"ModalContent_body__JnieZ","footer":"ModalContent_footer__VENcI","dark-mode":"ModalContent_dark-mode__lwtz9"};